export default __webpack_public_path__ + "static/media/hht1_ep20_minisitcom_01.64338401.png";